module.exports = __webpack_public_path__ + "images/f16f75688ed8e426dfacf15d8227ac7e.png";